import GET_VISITOR_PROFILES from '@/graphql/VisitorProfiles/getVisitorProfiles.gql';
import { graphClient } from '../main';

export default class VisitorProfilesResource {
    /*
        options = {
            name
        }
    */
    async get (options) {
        return await graphClient.query({
            query: GET_VISITOR_PROFILES,
            variables: {
                ...options
            },
            update: data => data
        })
    }
}
